import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=578b8894"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578b8894')) {
      api.createRecord('578b8894', component.options)
    } else {
      api.reload('578b8894', component.options)
    }
    module.hot.accept("./Notes.vue?vue&type=template&id=578b8894", function () {
      api.rerender('578b8894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Notes.vue"
export default component.exports